import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import ResourceAssign from 'chameleon-src/components/assign/ResourceAssign';
import getClassesByEP from 'chameleon-src/utility/getClassesByEP';

const ResourceAction = (props) => {
  const {
    item,
    subjectData,
    isAdminOrCoordinator,
    unitNumber,
    persistAssignedSections,
    savedClasses,
    userClasses,
    chosenEducationPeriodCode,
  } = props;

  const currentClasses = useMemo(
    () => getClassesByEP(userClasses, chosenEducationPeriodCode),
    [userClasses, chosenEducationPeriodCode],
  );

  return (
    <ResourceAssign
      items={[{ ...item, resourceId: item.id }]}
      videoResource={{ unit: { unitId: unitNumber } }}
      subject={subjectData}
      userClasses={currentClasses}
      savedClasses={savedClasses}
      hasNoClasses={!currentClasses.length}
      isAdminOrCoordinator={isAdminOrCoordinator}
      onSubmit={(sectionIds) => {
        persistAssignedSections(
          sectionIds.map((value) => Number.parseInt(value, 10)),
        );
      }}
      assignButton={
        <ButtonWithIcon
          isIcon
          isNaked
          className="bg-none"
          tabIndex={0}
          icon="person_add"
          iconClassName="text-gray-600"
          accessibility={{
            'aria-label': 'Assign Video',
          }}
        />
      }
      assignedButton={
        <ButtonWithIcon
          isIcon
          isSuccess
          tabIndex={0}
          icon="assigned"
          accessibility={{
            'aria-label': 'Assigned Video',
          }}
        />
      }
    />
  );
};

ResourceAction.propTypes = {
  item: PropTypes.object.isRequired,
  subjectData: PropTypes.object.isRequired,
  isAdminOrCoordinator: PropTypes.bool,
  unitNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  persistAssignedSections: PropTypes.func.isRequired,
  savedClasses: PropTypes.array,
  userClasses: PropTypes.array,
  chosenEducationPeriodCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

ResourceAction.defaultProps = {
  isAdminOrCoordinator: false,
  savedClasses: [],
  userClasses: [],
};

const mapStateToProps = (state) => {
  const {
    subject: { data: subjectData },
    userData: { isAdmin, isCoordinator, chosenEducationPeriodCode },
    classes: { items: userClasses },
  } = state;
  const isAdminOrCoordinator = isAdmin || isCoordinator;

  return {
    subjectData,
    isAdminOrCoordinator,
    chosenEducationPeriodCode,
    userClasses,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps),
  connectLean({
    scope: ({ unitNumber, item: { id, resourceId }, params: { subject } }) => [
      'units',
      `unit-${unitNumber}`,
      'resources',
      `resource-${resourceId || id}-subject-${subject}`,
    ],
    mapState: ({ withWatchedVideo, savedClasses }) => ({
      withWatchedVideo,
      savedClasses,
    }),
    persistAssignedSections(items) {
      this.setState({
        savedClasses: items,
        selectedItems: items,
      });
    },
  }),
)(ResourceAction);
